export default "__VITE_ASSET__BP2vJ6xP__"